"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * API V1
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.ConfirmOrderCampaignToJSON = exports.ConfirmOrderCampaignFromJSONTyped = exports.ConfirmOrderCampaignFromJSON = exports.instanceOfConfirmOrderCampaign = void 0;
var runtime_1 = require("../runtime");
/**
 * Check if a given object implements the ConfirmOrderCampaign interface.
 */
function instanceOfConfirmOrderCampaign(value) {
    var isInstance = true;
    return isInstance;
}
exports.instanceOfConfirmOrderCampaign = instanceOfConfirmOrderCampaign;
function ConfirmOrderCampaignFromJSON(json) {
    return ConfirmOrderCampaignFromJSONTyped(json, false);
}
exports.ConfirmOrderCampaignFromJSON = ConfirmOrderCampaignFromJSON;
function ConfirmOrderCampaignFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'totalQuantity': !(0, runtime_1.exists)(json, 'total_quantity') ? undefined : json['total_quantity'],
        'subtotal': !(0, runtime_1.exists)(json, 'subtotal') ? undefined : json['subtotal'],
        'shipping': !(0, runtime_1.exists)(json, 'shipping') ? undefined : json['shipping'],
        'tax': !(0, runtime_1.exists)(json, 'tax') ? undefined : json['tax'],
        'totalAmount': !(0, runtime_1.exists)(json, 'total_amount') ? undefined : json['total_amount'],
    };
}
exports.ConfirmOrderCampaignFromJSONTyped = ConfirmOrderCampaignFromJSONTyped;
function ConfirmOrderCampaignToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'total_quantity': value.totalQuantity,
        'subtotal': value.subtotal,
        'shipping': value.shipping,
        'tax': value.tax,
        'total_amount': value.totalAmount,
    };
}
exports.ConfirmOrderCampaignToJSON = ConfirmOrderCampaignToJSON;
